import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import withUser from '../HOC/HOCwithUser.jsx';
import TextField from '@material-ui/core/TextField';
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as actions from '../../actions';
import {
    Button,
    CircularProgress,
    Paper,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Chip,
    TableFooter
} from '@material-ui/core';
import ProgressiveImage from 'react-progressive-image';
import ContentLoader from 'react-content-loader';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';
import HOCSectionLoader from '../HOC/HOCSectionLoader.jsx';
import {
    getBookingStatusClass,
    convertTimestampToDate,
    BOOKING_STATUS_INCART,
    getBookingPaymentStatus,
    getBookingPaymentStatusClass,
    getPaymentType,
    getPaymentTypeClass,
    ROLE_CUSTOMER,
    ROLE_PROVIDER,
    PAYMENT_PENDING,
    PAYMENT_PARTIAL,
    secondsToHms,
    APP_NAME,
    BOOKING_STATUS_CANCELLED,
    BOOKING_STATUS_REJECTED,
    BOOKING_TYPE_CARD,
    BOOKING_TYPE_CASH
} from '../../utils/config/constants.js';
import { NotificationManager } from 'react-notifications';
import { getDay, tConvert } from '../../utils/config/constants';
import {
    BOOKING_STATUS_INITIATED,
    BOOKING_STATUS_CONFIRMED,
    BOOKING_STATUS_START,
    BOOKING_STATUS_PAUSED,
    BOOKING_STATUS_END,
    BOOKING_STATUS_COMPLETED
} from '../../utils/config/constants';
import withCustomTheme from '../HOC/HOCwithCustomTheme.jsx';
import { Redirect } from 'react-router-dom';
import RatingPopup from './RatingPopup.jsx';
import { Check } from '@material-ui/icons';

const styles = theme => ({
    root: {
        width: '100%'
    },
    inline: {
        display: 'inline'
    },
    margin: {
        margin: theme.spacing.unit
    },
    extendedIcon: {
        marginRight: theme.spacing.unit
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        marginBottom: '10px'
    }
});

let isMounted = false;

class BookingDetail extends React.Component {
    constructor(props) {
        super();
        this.state = {
            page: 1,
            scrollClicked: false,
            data: {},
            newAmount: "",
            reason:"",
            loader: true,
            showPaymentOption: false,
            cardPayment: false,
            walletPayment: false,
            ratePopup: false,
            bookingId: props.location.bookingId | props.bookingId,
            bookingList: false,
            actionLoader: false,
            redirect: false,
            ratingDone: false,
            isBookingCancelled: false,
            isRebooking: false,
            showPayButton: true,
            showAmountChangeOption: {open:false,value:'',reason:''},
        };
    }

    componentDidMount() {
        isMounted = true;
        this.getData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location.bookingId != this.props.location.bookingId) {
            if (isMounted) {
                this.getData();
            }
        }
    }

    getData = () => {
        this.props.bookingDetailAction(
            {
                bookingId: this.props.bookingId
            },
            this.onDone
        );
    };

    onDone = (success, {data}) => {
        if (success) {
            const amountObj = {valprice:0,reason:data.amount_reason};console.log({data})
            if(data.services !== 'undefined' && data.item_type == 1){
                amountObj.valPrice = data.services[0].present_charge;}
            else{
                amountObj.valPrice =  data.services[0].servicePrice;
            }
           
            this.setState((prevState)=>({ 
                data: data, 
                loader: false,
                showAmountChangeOption:{...prevState.showAmountChangeOption,
                    value:amountObj.valPrice,
                    reason:amountObj.reason}
            }));

        } else {
            this.setState({ loader: false });
            NotificationManager.success(data.message, 'Error');
        }
    };

    renderPromoImage = () => {
        return (
            <div style={{ width: 200, height: 200 }}>
                <ContentLoader
                    height={200}
                    width={200}
                    speed={2}
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect x="0" y="0" rx="2" ry="2" width="200" height="200" />
                </ContentLoader>
            </div>
        );
    };

    renderService = data => {
        if (!data.services) {
            return <CircularProgress />;
        } else {
            return (
                <div>
                    {data.services !== 'undefined' && data.item_type == 1
                        ? data.services[0].packageName
                        : data.services[0].service}
                </div>
            );
        }
    };

    renderServicePrice = data => {
        const {showAmountChangeOption} = this.state;
        if (!data.services) {
            return <CircularProgress />;
        } else {
            return (
                <div>
                    {this.props.settings.constants.CURRENCY_SYMBOL}
                    {showAmountChangeOption.value ? `${showAmountChangeOption.value} /hr *` :
                    data.services !== 'undefined' && data.item_type == 1
                        ? data.services[0].present_charge
                        : `${data.services[0].servicePrice} /hr`}
                </div>
            );
        }
    };
    
    cancelBooking = data => {
        this.props.cancelBookingAction(
            {
                bookingId: data.key
            },
            this.onCancelDone
        );
    };

    amountAccept = data => {
        console.log({data})
        this.props.amountAcceptAction(
            {
                bookingId: data.key
            },
            this.onamountAcceptDone
        );
        this.setState({ redirect: true });
    };

    amountReject = data => {
        this.props.amountRejectAction(
            {
                bookingId: data.key
            },
            this.onamountRejectDone
        );
        this.props.cancelBookingAction(
            {
                bookingId: data.key
            },
            this.onCancelDone
        );
        this.setState({ redirect: true });
    };

    onamountRejectDone = (success, data) => {
        if (success) {
           
            NotificationManager.success(
                <FormattedMessage
                    id="amountReject"
                    defaultMessage="Booking Amount Rejected Successfully"
                />,
                'Cancelled'
            );
        } else {
            NotificationManager.error(data, 'Error');
        }
    };

    onamountAcceptDone = (success, data) => {
        console.log({success,data})
        if (success) {
            NotificationManager.success(
                <FormattedMessage
                    id="amountAccept"
                    defaultMessage="Booking Amount Accepted Successfully"
                />,
                'Success'
            );
        } else {
            NotificationManager.success(data, 'Success');
        }
    };

    onCancelDone = (success, data) => {
        if (success) {
            this.setState({ isBookingCancelled: true });
            NotificationManager.success(
                <FormattedMessage
                    id="bookingCancelledSuccess"
                    defaultMessage="Booking Cancelled Successfully"
                />,
                'Cancelled'
            );
        } else {
            NotificationManager.error(data, 'Error');
        }
    };

    renderCancelOption = data => {
        let cancellationMinutes =
            parseInt(this.props.settings.constants.CANCELLATION_MINUTES) *
            60 *
            1000;
        let bookingDateTime = parseInt(data.datetime);
        let matchUpTime = bookingDateTime - cancellationMinutes;

        // matchUpTime = matchUpTime / 1000;

        if (
            (matchUpTime > new Date().getTime() &&
                data.status == BOOKING_STATUS_INITIATED) ||
            (matchUpTime > new Date().getTime() &&
                data.status == BOOKING_STATUS_CONFIRMED)
        ) {
            return (
                <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => this.cancelBooking(data)}
                >
                    <FormattedMessage
                        id="cancelBooking"
                        defaultMessage="Cancel Booking"
                    />
                </Button>
            );
        }
    };

    renderRebookOption = data => {
        if (this.props.userData.role === ROLE_CUSTOMER) {
            if (this.state.data.reschedule) {
                if (this.state.isRebooking) {
                    return <CircularProgress />;
                }
                return (
                    <Button
                        className="ml-2"
                        variant="outlined"
                        color="primary"
                        onClick={() => this.onRebook(data)}
                    >
                        <FormattedMessage id="rebook" defaultMessage="Rebook" />
                    </Button>
                );
            }
        }
    };

    renderAmountOption = data => {
        if (this.props.userData.role === ROLE_CUSTOMER) {
            if (this.state.data.newAmount) {
                if(this.state.data.amount_approved == 1) {
                  
                    return (
                        <React.Fragment>
                            
                            <Button
                            className="ml-2"
                            variant="outlined"
                            color="primary"
                            onClick={() => this.amountReject(data)}
                            >
                                <FormattedMessage id="reject" defaultMessage="Reject" />
                            </Button>
                            <Button
                            className="ml-2"
                            variant="outlined"
                            color="primary"
                            onClick={() => this.amountAccept(data)}
                            >
                       
                            <FormattedMessage id="accept" defaultMessage="Accept" />
                        </Button>
                    </React.Fragment>
                    );
                } 
                
            }
        }
    };

    onRebook = () => {
        this.setState({ isRebooking: true });
        this.props.reBookingAction(
            {
                bookingId: this.state.data.key
            },
            (success, data) => {
                this.setState({ isRebooking: false });
                if (success) {
                    this.props.history.push(
                        `/book/service/${data.providerDetail.id}/${data.webServiceId}`
                    );
                } else {
                    NotificationManager.error(data, 'Error');
                }
            }
        );
    };

    renderActions = data => {
        if (data.statusId == BOOKING_STATUS_INCART) {
            return (
                <div className="text-center">{this.renderPayButton(data)}</div>
            );
        } else if (data.statusId == BOOKING_STATUS_INITIATED) {
            return (
                <div className="text-center">
                    <p>
                        <b>
                            <FormattedMessage
                                id="waitingForProviderText"
                                defaultMessage="Waiting for provider to accept."
                            />
                        </b>
                    </p>
                </div>
            );
        } else if (
            data.statusId == BOOKING_STATUS_END ||
            data.statusId == BOOKING_STATUS_COMPLETED
        ) {
            return (
                <div className="text-center">
                    {data.item_type == 2 && this.renderPayButton(data)}
                    {this.renderReviewButton(data)}
                </div>
            );
        } else if (
            data.statusId == BOOKING_STATUS_CONFIRMED ||
            data.statusId == BOOKING_STATUS_START ||
            data.statusId == BOOKING_STATUS_PAUSED
        ) {
            return <div />;
        }
    };

    renderReviewButton = data => {
        if (!data.customer_reviewed && !this.state.ratingDone) {
            return (
                <Button
                    variant="contained"
                    color="primary"
                    onClick={this.showRatePopup}
                >
                    <FormattedMessage id="rate" defaultMessage="Rate" />
                </Button>
            );
        }
        return null;
    };
    showRatePopup = () => {
        this.setState({ ratePopup: true });
    };

    renderPayButton = data => {
        let checkCardValue = false;
        let { paymentOptions } = this.props.settings.constants;
        if (!data.customer_approved && this.state.showPayButton) {
            for (let x in paymentOptions) {
                if (paymentOptions[x].value === BOOKING_TYPE_CARD) {
                    checkCardValue = true;
                }
            }

            if (checkCardValue) {
                return (
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={this.showPaymentOptions}
                    >
                        <FormattedMessage id="pay" defaultMessage="Pay" />
                    </Button>
                );
            }
        }
        return null;
    };

    showPaymentOptions = () => {
        this.setState({ showPaymentOption: true });
    };

    renderAllPaymentOptions = () => {
        let { paymentOptions } = this.props.settings.constants;

        if (Array.isArray(paymentOptions)) {
            paymentOptions = paymentOptions.filter(function (item, index) {
                return item.label != 'Paypal' && item.label != 'Payfast';
            });
        }

        return (
            <div className="text-center">
                {paymentOptions &&
                    paymentOptions.map((option, index) => {
                        if (option.value != 1) {
                            return (
                                <Button
                                    style={{ marginRight: 10 }}
                                    key={index}
                                    variant="outlined"
                                    color="primary"
                                    value={option.value}
                                    name="paymentType"
                                    onClick={() =>
                                        this.proceedPayment(option.value)
                                    }
                                >
                                    <FormattedMessage
                                        id="payBy"
                                        defaultMessage="Pay by *"
                                    />{' '}
                                    {option.label}
                                </Button>
                            );
                        }
                    })}
            </div>
        );
    };

    proceedPayment = value => {
        if (value == 2) {
            this.setState({ cardPayment: true });
        } else if (value == 3) {
            if(this.state.data.payment_status == PAYMENT_PARTIAL){
                this.props.walletPartialPayAction(
                    { bookingToken: this.state.data.token },
                    this.onPaymentDone
                );
            } else{
                this.props.walletPayAction(
                    { bookingToken: this.state.data.token },
                    this.onPaymentDone
                );
            }
            
            // this.setState({ walletPayment: true });
        } else if (value == 4) {
            this.setState({ redirectPayfastPayment: true });
        }
    };

    onPaymentDone = (success, data) => {
        if (success) {
            this.setState({ showPayButton: false });
            NotificationManager.success(data.message, 'Success');
            setInterval(() => {
                window.location.reload();
            }, 100);
        } else {
            NotificationManager.error(data.message, 'Error');
        }
        //api not working for now
    };
   

    bookingAction = type => {
        this.setState({ actionLoader: true });
        if (type == 1) {
            this.props.acceptBookingAction(
                { bookingToken: this.state.data.token },
                this.onActionDone
            );
        } else if (type == 2) {
            this.props.rejectBookingAction(
                { bookingToken: this.state.data.token },
                this.onActionDone
            );
        } else if (type == 3) {
            this.props.approvePaymentBookingAction(
                { bookingToken: this.state.data.token },
                this.onActionDone
            );
        }
    };

    onActionDone = (success, data) => {
        if (success) {
            NotificationManager.success(
                <FormattedMessage
                    id="actionCompleted"
                    defaultMessage="Action Completed"
                />,
                'Success'
            );
            this.setState({ redirect: true });
        } else {
            NotificationManager.error(
                <FormattedMessage
                    id="someErrorOccurred"
                    defaultMessage="Some Error Occured"
                />,
                'Error'
            );
        }
    };

    renderProviderOptions = data => {
        if (this.state.actionLoader) {
            return (
                <div className="text-center">
                    <CircularProgress />
                </div>
            );
        } else {
            if (data.statusId == BOOKING_STATUS_INITIATED) {
                return (
                    <div className="text-center">
                        <Button
                            style={{ marginRight: 10 }}
                            key="accept"
                            variant="outlined"
                            color="primary"
                            value="accept"
                            name="paymentType"
                            onClick={() => this.bookingAction(1)}
                        >
                            <FormattedMessage
                                id="accept"
                                defaultMessage="Accept"
                            />
                        </Button>

                        <Button
                            style={{ marginRight: 10 }}
                            key="reject"
                            variant="outlined"
                            color="primary"
                            value="reject"
                            name="paymentType"
                            onClick={() => this.bookingAction(2)}
                        >
                            <FormattedMessage
                                id="reject"
                                defaultMessage="Reject"
                            />
                        </Button>
                    </div>
                );
            } else if (
                data.statusId == BOOKING_STATUS_END &&
                data.payment_status == PAYMENT_PENDING
            ) {
                return (
                    <div className="text-center">
                        <Button
                            style={{ marginRight: 10 }}
                            key="accept"
                            variant="contained"
                            color="primary"
                            value="complete"
                            name="paymentType"
                            onClick={() => this.bookingAction(3)}
                        >
                            <Check />{' '}
                            <FormattedMessage
                                id="approvePayment"
                                defaultMessage="Approve Payment"
                            />
                        </Button>
                    </div>
                );
            }
            
            
        }
    };

    handleRatingClose = () => {
        this.setState({ ratePopup: false });
    };

    ratingDoneCheck = () => {
        this.setState({ ratingDone: true });
    };

    handleChangeAmount = () => {
        this.setState((prevState)=>({ 
            showAmountChangeOption:{...prevState.showAmountChangeOption,open:true}
        }));
       
    };

    submit = ({value,reason}, bookingToken) => {
        this.setState({ loader: true });
        this.props.newBookingAmountAction(
            {
                newAmount:value,
                amount_reason:reason,
                bookingToken
            },
            this.amountDone
        );
    };

    amountDone = (success, data) => {
        this.setState({ loader: false });
        if (success) {
            NotificationManager.success(data.message, 'Success');
        }
    };
    handleCancel=()=>{
        this.setState((prevState)=>({ 
            showAmountChangeOption:{...prevState.showAmountChangeOption,open:false}
        }));
    }
    handleNewAmountChange=(textValue,type)=>{
        console.log({type})
        if(type ==='value'){
            this.setState((prevState)=>({ 
                showAmountChangeOption:{...prevState.showAmountChangeOption,value:textValue}
            }));
        }else{
            this.setState((prevState)=>({ 
            showAmountChangeOption:{...prevState.showAmountChangeOption,reason:textValue}
        }));
}
    }
    render() {
        const { classes, userData, settingsValues, bookingData } = this.props;
        const { formatMessage } = this.props.intl;
        const { data, loader,showAmountChangeOption } = this.state;
        console.log({data})
        if (this.state.cardPayment) {
            this.props.history.push({
                pathname: `/booking/payment/${this.state.data.key}`
            });
        }
        if (this.state.redirect) {
            this.props.history.push({
                pathname: `/provider/booking`
            });
        }

        if (this.state.redirectPayfastPayment) {
            return (
                <Redirect
                    to={{
                        pathname: `/booking/payfastpayment/${this.state.data.key}`
                    }}
                />
            );
        }

        return (
          
            <div>
                <HOCSectionLoader loading={loader}>
                    <Paper>
                        <div className="tableWrapper-table">
                            <Table className="table dashboard-tables">
                                <TableHead>
                                    {this.props.userData.role ==
                                        ROLE_PROVIDER && (
                                            <TableRow>
                                                <TableCell colSpan="2">
                                                    {data.status != 'Cancelled' &&
                                                        !this.state
                                                            .isBookingCancelled &&
                                                        this.renderCancelOption(
                                                            data
                                                        )}
                                                     
                                                    {this.renderRebookOption(data)}
                                                </TableCell>
                                            </TableRow>
                                        )}

                                    <TableRow>
                                        <TableCell>
                                            <h4>
                                                <FormattedMessage
                                                    id="bookingId"
                                                    defaultMessage="Booking ID"
                                                />
                                                : {data.token}
                                            </h4>
                                        </TableCell>
                                        <TableCell>
                                            <Chip
                                                className={getBookingStatusClass(
                                                    !this.state
                                                        .isBookingCancelled
                                                        ? data.status
                                                        : 'Cancelled'
                                                )}
                                                label={
                                                    !this.state
                                                        .isBookingCancelled
                                                        ? data.status
                                                        : 'Cancelled'
                                                }
                                            />
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        {data.bookingImage && (
                                            <TableCell>
                                                <img
                                                    width="200px"
                                                    height="200px"
                                                    className="mobile-img-table"
                                                    src={
                                                        data.bookingImage.medium
                                                    }
                                                />
                                            </TableCell>
                                        )}
                                        <TableCell>
                                            <div>
                                                <div>
                                                    <h4>
                                                        <b>{data.provider}</b>
                                                    </h4>
                                                    <h5>
                                                        <FormattedMessage
                                                            id="contactDetails"
                                                            defaultMessage="Contact Details"
                                                        />
                                                    </h5>
                                                    {data.providerAddress && (
                                                        <div>
                                                            <p>
                                                                {
                                                                    data
                                                                        .providerAddress
                                                                        .address_line1
                                                                }
                                                            </p>
                                                            <h5>
                                                                <FormattedMessage
                                                                    id="phone"
                                                                    defaultMessage="Phone"
                                                                />
                                                            </h5>
                                                            <p>
                                                                {
                                                                    data
                                                                        .providerAddress
                                                                        .phone
                                                                }
                                                            </p>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            {data.bookingImage && (
                                                <img
                                                    width="200px"
                                                    className="mobile-img-table"
                                                    height="200px"
                                                    src={data.image.medium}
                                                />
                                            )}
                                        </TableCell>
                                        <TableCell className="text-left">
                                            {data.customerAddress && (
                                                <div>
                                                    <h4>
                                                        <b>
                                                            {
                                                                data
                                                                    .customerAddress
                                                                    .name
                                                            }
                                                        </b>
                                                    </h4>
                                                    <h5>
                                                        <FormattedMessage
                                                            id="contactDetails"
                                                            defaultMessage="Contact Details"
                                                        />
                                                    </h5>

                                                    <div>
                                                        <p>
                                                            {
                                                                data
                                                                    .customerAddress
                                                                    .address_line1
                                                            }
                                                            {', '}
                                                            {
                                                                data
                                                                    .customerAddress
                                                                    .city
                                                            }
                                                            {', '}
                                                            {
                                                                data
                                                                    .customerAddress
                                                                    .country
                                                            }
                                                            {', '}
                                                            {
                                                                data
                                                                    .customerAddress
                                                                    .zipcode
                                                            }
                                                        </p>
                                                        <h5>
                                                            <FormattedMessage
                                                                id="phone"
                                                                defaultMessage="Phone"
                                                            />
                                                        </h5>
                                                        <p>
                                                            {
                                                                data
                                                                    .customerAddress
                                                                    .phone
                                                            }
                                                        </p>
                                                    </div>
                                                </div>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <h4>
                                                <b>
                                                    {data.item_type == 1 ? (
                                                        <FormattedMessage
                                                            id="package"
                                                            defaultMessage="Package"
                                                        />
                                                    ) : (
                                                            <FormattedMessage
                                                                id="services"
                                                                defaultMessage="Services"
                                                            />
                                                        )}
                                                </b>
                                            </h4>
                                        </TableCell>

                                        <TableCell>
                                            <h4>{this.renderService(data)}</h4>
                                        </TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell>
                                            <h4>
                                                <b>
                                                    <FormattedMessage
                                                        id="schedule"
                                                        defaultMessage="Schedule"
                                                    />
                                                </b>
                                            </h4>
                                        </TableCell>

                                        <TableCell>
                                            <h4>
                                                {convertTimestampToDate(
                                                    data.datetime
                                                )}{' '}
                                                | {getDay(data.datetime)}
                                            </h4>

                                            <Chip
                                                color="primary"
                                                label={tConvert(
                                                    new Date(data.datetime)
                                                )}
                                            />
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <h4>
                                                <b>
                                                    <FormattedMessage
                                                        id="subAmount"
                                                        defaultMessage="Sub Amount"
                                                    />
                                                </b>
                                            </h4>
                                        </TableCell>

                                        <TableCell>
                                            <h4>
                                             {this.renderServicePrice(data)}
                                            </h4>
                                        </TableCell>
                                    </TableRow>
                                    {data.amount_reason && (
                                        <TableRow>
                                        <TableCell>
                                            <h4>
                                                <b>
                                                    <FormattedMessage
                                                        id="reason"
                                                        defaultMessage="Reason"
                                                    />
                                                </b>
                                            </h4>
                                        </TableCell>

                                        <TableCell>
                                            <h4>
                                                {showAmountChangeOption.reason? showAmountChangeOption.reason:data.amount_reason}
                                            </h4>
                                        </TableCell>
                                        </TableRow>
                                    )}
                                   
                                    <TableRow>
                                        <TableCell>
                                            <h4>
                                                <b>
                                                    <FormattedMessage
                                                        id="promoCodeApplied"
                                                        defaultMessage="Promo Code Applied"
                                                    />
                                                </b>
                                            </h4>
                                        </TableCell>

                                        <TableCell>
                                            <h4>
                                                {data.promo_code
                                                    ? data.promo_code.code
                                                    : '-'}
                                            </h4>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <h4>
                                                <b>
                                                    <FormattedMessage
                                                        id="totalAmount"
                                                        defaultMessage="Total Amount"
                                                    />
                                                </b>
                                            </h4>
                                        </TableCell>

                                        <TableCell>
                                            <h4>
                                                {
                                                    this.props.settings
                                                        .constants
                                                        .CURRENCY_SYMBOL
                                                }
                                                {data.total_amount
                                                    ? data.total_amount
                                                    : '0'}
                                            </h4>
                                        </TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell>
                                            <h4>
                                                <b>
                                                    <FormattedMessage
                                                        id="paymentStatus"
                                                        defaultMessage="Payment Status"
                                                    />
                                                </b>
                                            </h4>
                                        </TableCell>

                                        <TableCell>
                                            <Chip
                                                className={getBookingPaymentStatusClass(
                                                    data.payment_status
                                                )}
                                                label={getBookingPaymentStatus(
                                                    data.payment_status
                                                )}
                                            />
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <h4>
                                                <b>
                                                    <FormattedMessage
                                                        id="paymentType"
                                                        defaultMessage="Payment Type"
                                                    />
                                                </b>
                                            </h4>
                                        </TableCell>

                                        <TableCell>
                                            <Chip
                                                className={getPaymentTypeClass(
                                                    data.payment_type
                                                )}
                                                label={getPaymentType(
                                                    data.payment_type
                                                )}
                                            />
                                        </TableCell>
                                    </TableRow>

                                    <TableRow>
                                        <TableCell>
                                            <h5>
                                                <b>
                                                    <FormattedMessage
                                                        id="additionalNote"
                                                        defaultMessage="Additional Note"
                                                    />
                                                </b>
                                            </h5>
                                        </TableCell>
                                        <TableCell>
                                            <h5>
                                                <b>{data.note}</b>
                                            </h5>
                                        </TableCell>
                                    </TableRow>
                                    {data.rating && (
                                        <TableRow>
                                            <TableCell>
                                                <h4>
                                                    <b>
                                                        <FormattedMessage
                                                            id="rating"
                                                            defaultMessage="Rating"
                                                        />
                                                    </b>
                                                </h4>
                                            </TableCell>

                                            <TableCell>
                                                <h4>
                                                    {data.rating
                                                        ? data.rating.ar
                                                        : ''}
                                                    /5
                                                </h4>

                                                <p>
                                                    {data.rating
                                                        ? `( ${data.rating.review} )`
                                                        : ''}
                                                </p>
                                            </TableCell>
                                        </TableRow>
                                    )}
                                    <TableRow>
                                        <TableCell colSpan="2">
                                            <h4>
                                                <FormattedMessage
                                                    id="createdAt"
                                                    defaultMessage="Created At"
                                                />
                                                :
                                                {convertTimestampToDate(
                                                    data.created_at
                                                )}
                                            </h4>
                                        </TableCell>
                                    </TableRow>
                                    {userData.role == ROLE_PROVIDER  && data.statusId==5  && !data.newAmount && data.newAmount == 0 &&
                                    <TableRow>
                                        <TableCell colSpan="2">
                                            <Button
                                                variant="contained"
                                                style={{
                                                    backgroundColor: this.props.theme.palette.primary.main,
                                                    color: '#ffffff',
                                                    fontSize: '16px'
                                                }}
                                                size="large"
                                                onClick={this.handleChangeAmount}
                                            >
                                                <FormattedMessage id="additionalAmount" defaultMessage="Change Service Price" />
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                    }
                                    
                                    {userData.role == ROLE_PROVIDER && data.statusId==5  && this.state.showAmountChangeOption.open && !data.newAmount && data.newAmount == 0 && (
                                        <React.Fragment>
                                            <TableRow>
                                                <TableCell colSpan="2">
                                                    <TextField
                                                        className="login-form-textfield"
                                                        id="newAmount"
                                                        fullWidth
                                                        name="newAmount"
                                                        label={formatMessage({
                                                            id: 'newAmount'
                                                        })}
                                                        type="text"
                                                        value={showAmountChangeOption.value && showAmountChangeOption.value}
                                                        onChange={event => {
                                                            this.handleNewAmountChange(event.target
                                                                .value,'value')
                                                        }}
                                                        disabled={
                                                            this.state
                                                                .loaderButton
                                                        }
                                                        margin={'normal'}
                                                        title="Enter Extra Amount"
                                                    />
                                                    <TextField
                                                        className="login-form-textfield"
                                                        id="reason"
                                                        fullWidth={true}
                                                        name="reason"
                                                        label={formatMessage({
                                                            id: 'reason'
                                                        })}
                                                        type="reason"
                                                        value={showAmountChangeOption.reason}
                                                        onChange={event => {
                                                            this.handleNewAmountChange(event.target
                                                                .value,'reason')
                                                        }}
                                                        disabled={
                                                            this.state
                                                                .loaderButton
                                                        }
                                                        margin={'normal'}
                                                        title="Enter Reason"
                                                    />
                                                    <Button
                                                        variant="contained"
                                                        style={{
                                                            backgroundColor: this.props.theme.palette.primary.main,
                                                            color: '#ffffff',
                                                            fontSize: '16px',
                                                            marginRight:'20px'
                                                        }}
                                                        size="large"
                                                        onClick={() => {
                                                            this.submit(showAmountChangeOption,data.token)
                                                        }
                                                        }
                                                    >
                                                        <FormattedMessage id="submit" defaultMessage="Submit" />
                                                    </Button>
                                                    <Button
                                                        variant="contained"
                                                        style={{
                                                            backgroundColor: "#000000",
                                                            color: '#ffffff',
                                                            fontSize: '16px',
                                                            marginRight:'20px'
                                                        }}
                                                        size="large"
                                                        onClick={this.handleCancel}
                                                    >
                                                        <FormattedMessage id="cancel" defaultMessage="Cancel" />
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        </React.Fragment>
                                    )}
                                </TableBody>
                                {userData.role == ROLE_CUSTOMER && (
                                    <TableFooter>
                                        <TableRow>
                                            <TableCell colSpan="2">
                                                {!this.state.showPaymentOption
                                                    ? this.renderActions(data)
                                                    : this.renderAllPaymentOptions(
                                                        data
                                                    )}
                                            </TableCell>
                                        </TableRow>
                                        {data.amount_approved === 1 && (
                                            <TableRow>
                                            <TableCell colSpan="2">
                                                <h4>Approve/Reject updated amount</h4>
                                                <p></p>
                                                    {data.newAmount && data.newAmount > 0 &&( 
                                                       this.renderAmountOption(
                                                            data
                                                     ))}
                                            </TableCell>
                                        </TableRow>
                                        )}
                                    </TableFooter>
                                )}

                                <TableFooter>
                                    {userData.role == ROLE_PROVIDER && (
                                        <TableRow>
                                            <TableCell colSpan="2">
                                                {this.renderProviderOptions(
                                                    data
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    )}
                                    <TableRow>
                                        <TableCell colSpan="2">
                                            {data.status != 'Cancelled' &&
                                                !this.state
                                                    .isBookingCancelled &&
                                                this.renderCancelOption(data)}

                                            {this.renderRebookOption(data)}
                                        </TableCell>
                                    </TableRow>
                                </TableFooter>
                            </Table>
                        </div>
                    </Paper>

                    {this.state.ratePopup && (
                        <RatingPopup
                            open={this.state.ratePopup}
                            close={this.handleRatingClose}
                            r1Value={this.props.settings.constants.R1}
                            r2Value={this.props.settings.constants.R2}
                            r3Value={this.props.settings.constants.R3}
                            arValue={this.props.settings.constants.AR}
                            starRatedColor={
                                this.props.settings.colors.RATING.HEX
                            }
                            bookingToken={this.state.data.token}
                            reviewDone={this.ratingDoneCheck}
                        />
                    )}
                </HOCSectionLoader>
            </div>
        );
    }
}

const mapStateToProps = ( settings, booking ) => {
    return { settingsValues: settings, bookingData:booking };
};
const composedComponent = compose(
    withStyles(styles),
    connect(mapStateToProps, actions)
);
export default composedComponent(withCustomTheme(injectIntl(BookingDetail)));



// WEBPACK FOOTER //
// ./src/components/Customer/BookingDetail.jsx